module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0032.950d2003.jpg";